// These are facts from the championship source, not the selected pursuit view.
// Missing optional flags do not invent an error, but every explicit negative
// survives through snapshot and paged loads. Cursor exhaustion is still required.
export function championshipSourceEvidence(response = {}, previous = null) {
  const read = response?.read || {}
  const issues = [...(previous?.issues || [])]
  const unreadable = [...new Set([...(previous?.unreadable || []), ...(response?.unreadable || []), ...(read.unreadable || [])])]
  if (read.whole === false || unreadable.length) issues.push('source_unreadable')
  if (response?.refreshError || read.refreshError) issues.push('refresh_error')
  if (response?.error || read.error || (Array.isArray(response?.errors) && response.errors.length)
    || (Array.isArray(read.errors) && read.errors.length)) issues.push('source_error')
  if (response?.ok === false || read.ok === false || response?.ready === false || read.ready === false) issues.push('source_unready')
  if (response?.complete === false || read.complete === false || response?.partial === true || read.partial === true
    || response?.capped === true || read.capped === true || response?.truncated === true || read.truncated === true) issues.push('source_incomplete')
  if (response?.degraded || read.degraded) issues.push('source_degraded')
  return { unreadable, healthy: previous?.healthy !== false && issues.length === 0, issues: [...new Set(issues)] }
}

export function championshipPlaneIsComplete(champ = {}) {
  if (champ.complete !== true || champ.status !== 'done' || champ.error || champ.building || champ.demo) return false
  if (champ.asOf?.refreshError || champ.readEvidence?.healthy !== true) return false
  // A successful exhausted live walk can replace a failed fast-path read. Its
  // informational fallback message is not itself degraded source data.
  if (champ.loadMode === 'paged') return true
  return champ.loadMode === 'snapshot' && !champ.degraded
}
